// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"SinglePage_backgroundImage__Tg7KH","background":"SinglePage_background__1X6iB","main":"SinglePage_main__2ZLYU"};